// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Oc-z","subtitle":"Pc-z","contentWrap":"Qc-z","imgWrap":"Rc-z","heading":"Sc-z","copy":"Tc-z"};